// HELPERS
// ----------------------------------------------------------------------
import { CreditCard } from "utils/CreditCard";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { GlamboxRecaptcha } from "core/glambox/GlamboxRecaptcha";
import { UiActions } from "state/actions/UiActions";
import { SubscriberRenewalRequest } from "../../core/types/SubscriberRenewalRequest";
import { PaymentMethod } from "../../core/types/PaymentMethod";
import { CreditCard as CreditCardEntity } from "core/types/CreditCard";

export const Steps = {
  STEP_INFORMATION: 0,
  STEP_ACCOUNT_DATA: 1,
  STEP_PERSON_DATA: 2,
  STEP_BILLING_ADDRESS: 3,
  STEP_SHIPPING_ADDRESS: 4,
  STEP_PAYMENT: 5,
  STEP_SUBMIT_FINAL: 6 //TESTANDO
  // STEP_SUBMIT_CONFIRMATION: 6,
  //STEP_SUBMIT_FINAL: 7,
  //STEP_DONUT_FOR_YOU: 8
};

export const PartnerPathInitialState = () => ({
  step: Steps.STEP_INFORMATION,

  shippingIsBilling: true,

  city: null,
  state: null,

  accept: false,

  account: {},
  person: {},
  subscriber: {},

  cities: {},
  states: {},
  
  reactivatePending: true
});

const Clamp = (value, min, max) => {
  return Math.max(min, Math.min(value, max));
};

const SkipStep = (value, step) => {
  return Clamp(
    value + step,
    Steps.STEP_INFORMATION,
    Steps.STEP_SUBMIT_FINAL
  );
};

// TYPES
// ----------------------------------------------------------------------

export const Types = {
  setStep:                  "PARTNER_PATH/SET_STEP",
  setPerson:                "PARTNER_PATH/SET_PERSON",
  setAccount:               "PARTNER_PATH/SET_ACCOUNT",
  setBilling:               "PARTNER_PATH/SET_BILLING",
  setShipping:              "PARTNER_PATH/SET_SHIPPING",
  setStates:                "PARTNER_PATH/SET_STATES",
  setStateCities:           "PARTNER_PATH/SET_STATE_CITIES",
  setPayment:               "PARTNER_PATH/SET_PAYMENT",
  setReactivateInfo:        "PARTNER_PATH/SET_REACTIVATE_INFO",
  setSubscriber:            "PARTNER_PATH/SET_SUBSCRIBER",
  setCheckoutRequest:       "PARTNER_PATH/SET_CHECKOUT_REQUEST",
  setNextEdition:           "PARTNER_PATH/SET_NEXT_EDITION",
  setSubscription:          "PARTNER_PATH/SET_SUBSCRIPTION",
  toggleShippingIsBilling:  "PARTNER_PATH/TOGGLE_SHIPPING",
  setReactivatePending:     "PARTNER_PATH/SET_REACTIVATE_PENDING"
};

// REDUCER
// ----------------------------------------------------------------------

const Reducer = (state = {}, action) => {
  switch (action.type) {
    case Types.setReactivatePending:
      return Object.assign({}, state, {
        reactivatePending: action.payload.reactivatePending
      });
      
    case Types.setAccount:
      return Object.assign({}, state, {
        account: Object.assign({}, state.account, action.payload.account)
      });

    case Types.setPerson:
      return Object.assign({}, state, {
        person: Object.assign({}, state.person, action.payload.person)
      });

    case Types.setBilling:
      return Object.assign({}, state, {
        billing: Object.assign({}, state.billing, action.payload.billing)
      });

    case Types.setShipping:
      return Object.assign({}, state, {
        shipping: Object.assign({}, state.shipping, action.payload.shipping)
      });

    case Types.setStates:
      return Object.assign({}, state, {
        states: action.payload.states
      });

    case Types.setStateCities:
      return Object.assign({}, state, {
        cities: Object.assign({}, state.cities, {
          [action.payload.stateId]: action.payload.cities
        })
      });

    case Types.setPayment:
      return Object.assign({}, state, {
        payment: Object.assign({}, state.payment, action.payload.payment)
      });
      
    case Types.setReactivateInfo:
      return Object.assign({}, state, {
        reactivateInfo: action.payload.reactivateInfo
      });

    case Types.setSubscriber:
      return Object.assign({}, state, {
        subscriber: action.payload.subscriber
      });

    case Types.setCheckoutRequest:
      return Object.assign({}, state, {
        checkoutRequest: action.payload.checkoutRequest
      });

    case Types.setNextEdition:
      return Object.assign({}, state, {
        edition: action.payload.edition
      });

    case Types.setSubscription:
      return Object.assign({}, state, {
        subscription: action.payload.subscription
      });

    case Types.setStep:
      return Object.assign({}, state, action.payload);
      
    case Types.toggleShippingIsBilling:
      return Object.assign({}, state, {
        shippingIsBilling: !state.shippingIsBilling
      });

    default:
      return state;
  }
};

export default Reducer;

// ACTIONS
// ----------------------------------------------------------------------

export const BootstrapPartnerPath = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      person
    } = state;

    const accountData = {
      email: person.data.person.username,
      firstName: person.data.person.name,
      lastName: person.data.person.lastName,
      password: "qqrsenhapranaodarerro",
      passwordConfirmation: "qqrsenhapranaodarerro",
    };

    let val = person.data.person.cpf;
    if (val !== null && typeof val !== "undefined") {
      if (val && val.length < 11) {
        while (val.length < 11) {
          val = "0" + val;
        }
      }
    }

    const personData = {
      cpf: val,
      birthday: person.data.person.birthday,
      phone: person.data.person.phone
    };

    const billingData = {
      billingPostalCode: person.data.person.postalCode,
      billingState: person.data.person.state,
      billingCity: person.data.person.city,
      billingStreetNeighborhood: person.data.person.neighborhood,
      billingStreet: person.data.person.street,
      billingStreetNumber: person.data.person.streetNumber,
      billingStreetExtension: person.data.person.streetExtensions
    };

    dispatch(SetAccount(accountData));
    dispatch(SetPerson(personData));
    dispatch(SetBilling(billingData));
    dispatch(GetStates());

  }
};

const GetSubscriber = () => {

  return (dispatch, getState) => {

    const state = getState();
    const {
      subscribers,
      partnerInfo
    } = state;

    const lastSubscriberId = filterLastSubscriberId(subscribers.data);

    const subscriberData = {
      subscriberId: (lastSubscriberId === null)
        ? partnerInfo.subscriberId : lastSubscriberId
    }

    if (subscriberData.subscriberId) {

      dispatch(SetSubscriber(subscriberData));

      dispatch(GetReactivateInfo());
    } else {
      //se nao achou subscriber, precisa da informação da assinatura
      dispatch(SetMonthlySubscriptionInfo());
    }
  }
}

const SetMonthlySubscriptionInfo = () => {
  return (dispatch, getState) => {
    //const state = getState();

    dispatch(GetEdition());

    dispatch(GetShippingCost());

  }
}

const GetEdition = () => {
  return (dispatch, getState) => {
    ExecuteRequest(
      GlamboxEndpoints.Open.nextEdition,
      null,
      "GET",
      null,
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          dispatch(SetNextEdition(result));
        } else {
          //TODO
        }
      }
    );
  }
};

const GetShippingCost = () => {
  return (dispatch, getState) => {
    const state = getState();
    const { partnerCreate } = state;
    
    dispatch(SetReactivatePending(true));

    const data = {
      fetchShippingInfo: false, //TODO o que é?
      subscriptionTypeId: "1",
      shippingPostalCode: partnerCreate.shipping.shippingPostalCode,
      isRenewal: false,
      couponName: "" //TODO cupom de 50%
    }
    ExecuteRequest(
      GlamboxEndpoints.Open.shippingCost,
      data,
      "POST",
      null,
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;
    
        dispatch(SetReactivatePending(false));

        if (statusCode === 200) {
          dispatch(SetSubscriptionInfo(result));
        } else {
          //TODO
        }
      }
    );
  }
}

const filterLastSubscriberId = (subscribers) => {

  subscribers = subscribers.filter(sub => {
    return sub.subscriptionTypeId === 1
  });

  if (subscribers.length === 0) {
    return null;
  }

  const lastSubscriberId = subscribers.reduce(
    (max, sub) => (sub.id > max ? sub.id : max),
    subscribers[0].id
  );

  return lastSubscriberId;
}

export const GetReactivateInfo = (couponName = null) => {
  return (dispatch, getState) => {
    const state = getState();
    const { partnerCreate, subscribers } = state;
    const subscriberData = (subscribers.data) ? subscribers.data[0] : null;
    //if (subscriberData) {
    if (partnerCreate.subscriber) {
      dispatch(SetReactivatePending(true));
      
      ExecuteRequest(
        GlamboxEndpoints.Subscriber.reactivateInfo,
        {
          //subscriberId: partnerCreate.subscriber.subscriberId,
          subscriberId: subscriberData.subscriberId,
          couponName: couponName || null
        },
        "POST",
        {
          Authorization: state.token.data.Authorization,
        },
        null,
        (response) => {
          const {
            result,
            statusCode
          } = response;
    
          dispatch(SetReactivatePending(false));
          
          if (statusCode === 200) {
            dispatch(SetReactivateInfo(result));
            dispatch(SetPaymentData(result.creditCard));
          }
        }
      );
    } else {
      dispatch(GetShippingCost());
    }
  }
}

export const SetPaymentData = (creditCard) => {
  return (dispatch, getState) => {

    const paymentData = {
      flag: (creditCard !== null) ?
        CreditCard.getCardFlag(creditCard.number)
        : "",
      number: creditCard.number || "",
      maskedNumber: (creditCard !== null) ?
        creditCard.maskedNumber : "",
      cvv: creditCard.cvv || "",
      expMonth: (creditCard !== null) ?
        creditCard.expMonth : "",
      expYear: (creditCard !== null) ?
        creditCard.expYear : "",
      nameOnCard: (creditCard !== null) ?
        creditCard.nameOnCard : ""
    };
    dispatch(SetPayment(paymentData));
  }

}

export const GetStates = () => {
  return (dispatch) => {
    ExecuteRequest(
      GlamboxEndpoints.Open.listStates,
      null,
      "GET",
      null,
      null,
      (response) => {
        const {
          statusCode,
          result
        } = response;

        if (statusCode === 200) {
          dispatch(SetStates(result));

          for (let n in result) {
            let id = result[n].codigoIbge || result[n].codigoCep;
            dispatch(GetCities(id));
          }
        }
      }
    );
  };
};

export const GetCities = (stateId, callback) => {
  return (dispatch, getState) => {
    const state = getState();

    if (state.partnerCreate.cities[stateId]) {
      if (typeof callback === "function") {
        callback(state.partnerCreate.cities[stateId]);
      }
      return null;
    }

    ExecuteRequest(
      GlamboxEndpoints.Open.listStateCities,
      {
        stateId: stateId
      },
      "GET",
      null,
      null,
      (response) => {

        const {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          dispatch(SetStateCities(stateId, result.result));
          if (typeof callback === "function") callback(result.result);
        }
      }
    );
  };
};

export const NextStep = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      partnerCreate
    } = state;

    const partnerInfo = state.partnerInfo.data.influencerStatus;
    let step = SkipStep(state.partnerCreate.step, 1);

    if (
      step === Steps.STEP_SHIPPING_ADDRESS
      && partnerCreate.shippingIsBilling === true
    ) {

      step = SkipStep(step, 1);
    }
    
    if (partnerInfo.toLowerCase() !== "glampartner"
      && step === Steps.STEP_PAYMENT
    ) {
      step = SkipStep(step, 1);
    } else if (partnerInfo.toLowerCase() === "glampartner") {
      dispatch(GetSubscriber());
    }

    if (step === Steps.STEP_SUBMIT_FINAL) {
      //se vip: voucher
      //normal nova: cria nova
      //normal antiga: renova a anterior
      if (!(Object.keys(partnerCreate.subscriber).length === 0
        && partnerCreate.subscriber.constructor === Object)
      ) {
        dispatch(SetRequestData());
      }
    }

    dispatch(SetStep(step));
  }
};

export const PrevStep = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      partnerCreate
    } = state;
    const partnerInfo = state.partnerInfo.data.influencerStatus;
    let step = Clamp(
      state.partnerCreate.step - 1,
      Steps.STEP_INFORMATION,
      Steps.STEP_SUBMIT_FINAL
    );

    if (
      ((!partnerInfo || partnerInfo.toLowerCase() !== "glampartner")
        && step === Steps.STEP_PAYMENT
      ) ||
      (
        step === Steps.STEP_SHIPPING_ADDRESS
        && partnerCreate.shippingIsBilling === true
      )
    ) {
      step = Clamp(
        step - 1,
        Steps.STEP_INFORMATION,
        Steps.STEP_SUBMIT_FINAL
      );
    }

    dispatch(SetStep(step));
  }
};

export const SetStep = (step) => ({
  type: Types.setStep,
  payload: {
    step
  }
});

export const SetPerson = (person) => ({
  type: Types.setPerson,
  payload: {
    person
  }
});

export const SetAccount = (account) => ({
  type: Types.setAccount,
  payload: {
    account
  }
});

const SetBillingRaw = (billing) => ({
  type: Types.setBilling,
  payload: {
    billing
  }
});

export const SetBilling = (billing) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(SetBillingRaw(billing));

    if (state.partnerCreate.shippingIsBilling === true) {
      const shippingData = {};
      for (let key of Object.keys(billing)) {
        const newKey = key.replace(/billing/g, "shipping");
        shippingData[newKey] = billing[key];
      }
      dispatch(SetShipping(shippingData));
    }
  };
};

export const SetShippingRaw = (shipping) => ({
  type: Types.setShipping,
  payload: {
    shipping
  }
});

export const SetShipping = (shipping) => {
  return (dispatch, getState) => {
    dispatch(SetShippingRaw(shipping));
    dispatch(GetSubscriber());
  };
};

export const SetStates = (states) => ({
  type: Types.setStates,
  payload: {
    states
  }
});

export const SetStateCities = (stateId, cities) => ({
  type: Types.setStateCities,
  payload: {
    stateId,
    cities
  }
});

export const SetPayment = (payment) => ({
  type: Types.setPayment,
  payload: {
    payment
  }
});

export const SetCheckoutRequest = (checkoutRequest) => ({
  type: Types.setCheckoutRequest,
  payload: {
    checkoutRequest
  }
});

export const SetReactivateInfo = (reactivateInfo) => ({
  type: Types.setReactivateInfo,
  payload: {
    reactivateInfo
  }
});

export const SetSubscriber = (subscriber) => ({
  type: Types.setSubscriber,
  payload: {
    subscriber
  }
});

export const Renew = (data) => {
  return (dispatch, getState) => {
    const state = getState();
    const { token } = state;

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.renewal,
      data,
      "POST",
      {
        Authorization: token.data.Authorization
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;


        if (statusCode === 200) {
          dispatch(UiActions.publishSuccessAlert("Assinatura renovada com sucesso!"));

          // let dataLayerEvent = {
          //   nome_etapa: "finalizacao_" + state.reativacaoRetencao,
          //   event: state.reativacaoRetencao,
          //   transactionId: state.reativacaoRetencao + data.subscriberId,
          //   transactionAffiliation: "Glambox",
          //   transactionTotal: subscription.info.price - subscription.cost.discountPrice,
          //   transactionShipping: subscription.cost.shippingPrice,
          //   transactionDiscount: subscription.cost.discountPrice,
          //   transactionCoupon: state.couponName,
          //   transactionTax: 0,
          //   transactionProducts: [{
          //     sku: state.reativacaoRetencao + subscription.info.subscriptionTypeId,
          //     name: state.reativacaoRetencao + subscription.info.subscriptionTypeId,
          //     category: state.reativacaoRetencao,
          //     price: subscription.info.price,
          //     quantity: 1
          //   }]
          // };

          // let hostname = window.location.hostname;
          // if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
          //   window.dataLayer = window.dataLayer || [];
          //   window.dataLayer.push(dataLayerEvent);
          // }
        } else {
          dispatch(UiActions.publishErrorAlert("Não foi possível renovar sua assinatura!"));
          dispatch(recaptchaRenew());
          //window.grecaptcha.execute();
        }

      })
  }
}

export const CreateSubscription = (data) => {
  return (dispatch, getState) => {
    const state = getState();

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.create,
      data,
      "POST",
      {
        Authorization: state.token.data.Authorization
      },
      (response) => {
        const {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          //TODO
          dispatch(UiActions.publishSuccessAlert("Assinatura criada com sucesso!"));
        } else {
          //TODO
          dispatch(UiActions.publishErrorAlert("Não foi possível criar sua assinatura!"));
          GlamboxRecaptcha.execute();
        }
      }
    );

  }
}

const recaptchaRenew = () => {
  return (dispatch, getState) => {
    GlamboxRecaptcha.execute();

    dispatch(UiActions.recaptchaRequest(true));
  }
};

const SetRequestData = () => {
  return (dispatch, getState) => {
    const state = getState();
    const { partnerCreate, ui, person } = state;
    const { payment, subscriber } = partnerCreate;

    let flag = CreditCard.getCardFlag(payment.number);

    let useActiveCard = false; //TESTANDO 

    let creditCard = new CreditCardEntity(),
      checkoutRequest = new SubscriberRenewalRequest(),
      paymentMethod = new PaymentMethod();

    creditCard.nameOnCard = payment.nameOnCard || "";
    creditCard.number = parseInt(payment.number) || 0;
    creditCard.cvv = payment.cvv || 0;
    creditCard.creditCardFlagId = (flag !== false) ? flag.id : "";
    creditCard.expMonth = payment.expMonth || 0;
    creditCard.expYear = payment.expYear || 0;

    checkoutRequest.couponName = null;
    checkoutRequest.personId = person.data.person.id;
    checkoutRequest.subscriberId = subscriber.subscriberId;
    checkoutRequest.subscriptionTypeId = 1;
    checkoutRequest.useActiveCard = useActiveCard;
    checkoutRequest.captcha = ui.recaptcha;

    if (useActiveCard === false) {
      checkoutRequest.listPaymentMethod.push(paymentMethod);
      paymentMethod.creditCard = creditCard;
    }
console.log(paymentMethod)

    //dispatch(Renew(checkoutRequest.toObject(true))); comentado teste

    dispatch(CreateSubscription(checkoutRequest.toObject(true)));

  }
};

export const SetNextEdition = (edition) => ({
  type: Types.setNextEdition,
  payload: {
    edition
  }
})

export const SetSubscriptionInfo = (subscription) => ({
  type: Types.setSubscription,
  payload: {
    subscription
  }
});

export const ToggleShippingIsBilling = () => ({
  type: Types.toggleShippingIsBilling
});

export const SetReactivatePending = (status) => ({
  type: Types.setReactivatePending,
  payload: {
    reactivatePending: status
  }
});
